/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Status_ConnectingInputs */

const en_live_caption_status_connecting = /** @type {(inputs: Live_Caption_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting`)
};

const fr_live_caption_status_connecting = /** @type {(inputs: Live_Caption_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De liaison`)
};

const de_live_caption_status_connecting = /** @type {(inputs: Live_Caption_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung`)
};

const it_live_caption_status_connecting = /** @type {(inputs: Live_Caption_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collegamento`)
};

const ru_live_caption_status_connecting = /** @type {(inputs: Live_Caption_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключение`)
};

const es_live_caption_status_connecting = /** @type {(inputs: Live_Caption_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando`)
};

const zh_cn2_live_caption_status_connecting = /** @type {(inputs: Live_Caption_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接`)
};

const ja_live_caption_status_connecting = /** @type {(inputs: Live_Caption_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続中`)
};

const hi_live_caption_status_connecting = /** @type {(inputs: Live_Caption_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कनेक्ट`)
};

const pt_pt2_live_caption_status_connecting = /** @type {(inputs: Live_Caption_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando`)
};

/**
* | output |
* | --- |
* | "Connecting" |
*
* @param {Live_Caption_Status_ConnectingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_status_connecting = /** @type {((inputs?: Live_Caption_Status_ConnectingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Status_ConnectingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_status_connecting(inputs)
	if (locale === "de") return de_live_caption_status_connecting(inputs)
	if (locale === "it") return it_live_caption_status_connecting(inputs)
	if (locale === "ru") return ru_live_caption_status_connecting(inputs)
	if (locale === "es") return es_live_caption_status_connecting(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_status_connecting(inputs)
	if (locale === "ja") return ja_live_caption_status_connecting(inputs)
	if (locale === "hi") return hi_live_caption_status_connecting(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_status_connecting(inputs)
	return en_live_caption_status_connecting(inputs)
});